<template>
  <div>
    <div class='sl_form_title'>
      <h3>Child tasks</h3>
    </div>
    <v-divider class='mt-2'></v-divider>
    <div class="sl_comments__body">
      <v-list v-if="isDesktop" class="tasks_page__list pa-0">
        <template v-for="task in children">
          <v-list-tile
              class="tasks_page__list--item"
              :to="{ name: 'tasks-form', params: {project_id: task.project_id, task_id: task.id }}"
              tag="a"
          >
            <v-list-tile-content>
              <v-list-tile-title>
                <div>
                  <div class="tasks_page__list--item_chip tasks_page__list--item_chip-small">{{ task.short_name.toUpperCase() }}</div>
                  <nested-icons class="tasks_page__list--item_chip-small" :task="task"></nested-icons>
                  <strong>{{ task.title }}</strong>
                </div>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-btn title="Disassociate" @click.stop.prevent="openDetachModal(task.id)" class="my-0" color="secondary" small icon>
              <v-icon color="accent">clear</v-icon>
            </v-btn>
            <v-btn title="Archive" @click.stop.prevent="openRemoveModal(task)" class="my-0" color="secondary" small icon>
              <v-icon color="accent">archive</v-icon>
            </v-btn>
          </v-list-tile>
          <v-divider></v-divider>
          <div class="d-flex justify-space-between align-center">
            <div v-if="task.labels && task.labels.length" class="tasks_page__list--item_labels">
              <div
                  v-for="label in task.labels"
                  class="tasks_page__list--item_chip"
                  :style="{ color: label.text_color, 'background-color': label.color}"
              >
                {{ label.name }}
              </div>
            </div>
            <div v-else></div>
            <div :style="{ flex: 'unset!important' }">
              <div class="d-inline-block" v-if="task.column">{{ task.column.name }}</div>
              <div class="d-inline-block" v-if="task.instance_users && task.instance_users.length">
                <v-btn color="primary" icon v-for="user in task.instance_users" small>{{ user.short_name }}</v-btn>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
        </template>
      </v-list>
    </div>
    <archive-dialog ref="archiveDialog" confirm_text="Are you sure you want to delete it?" @yes="archiveTask"></archive-dialog>
    <detach-dialog ref="detachDialog" confirm_text="Are you sure you want to disassociate?" @yes="detachTask"></detach-dialog>
  </div>
</template>

<script>
  import * as mixins from '@/mixins'
  import confirm from '@/components/confirm-dialog'
  import nested from '@/components/tasks/nested'

  export default {
    name: 'TaskChildren',
    props: {
      'children': {
        type: Array,
        default: () => []
      },
    },
    mixins: [mixins.removable, mixins.preloader],
    data() {
      return {
        currentTask: {},
        detachableId: 0,
        api: this.$api.tasks
      }
    },
    methods: {
      openRemoveModal(task) {
        this.currentTask = task
        this.$refs.archiveDialog.open()
      },
      archiveTask() {
        if (!this.currentTask.id) return

        this.api.delete(this.currentTask.id).then(() => {
          this.refresh()
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'The task has been archived.'
          })
        }, () => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: 'Something went wrong.'
          })
        })
      },
      refresh() {
        this.$emit('refresh')
      },
      openDetachModal(taskId) {
        this.detachableId = taskId
        this.$refs.detachDialog.open()
      },
      detachTask() {
        this.api.detach(this.$route.params.task_id, this.detachableId).then(() => {
          this.refresh()
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'The task has been disassociated.'
          })
        }, () => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: 'Something went wrong.'
          })
        })
      }
    },
    components: {
      "archive-dialog": confirm,
      "detach-dialog": confirm,
      "nested-icons": nested,
    }
  }
</script>
